import styled from 'styled-components';
export var Content = styled.main.withConfig({
  displayName: "Content",
  componentId: "sc-1yh730l-0"
})(["display:flex;flex:1;flex-direction:column;width:100%;", ""], function (_ref) {
  var fullHeight = _ref.fullHeight;
  return fullHeight ? 'min-height: 100vh;' : '';
});